if (!customElements.get('taven-lifestyle-carousel')) {
  customElements.define('taven-lifestyle-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.tm-lifestyle-slide')];
      if (this.slides.length < 2) return;
      this.index = Math.floor(Date.now() / 86400000) % this.slides.length;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('.tm-lifestyle-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + (e.key === 'ArrowLeft' ? -1 : 1)); } }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
      }
      this.show(this.index);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.play : this.pauseButton.dataset.stop;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      if (!this.paused && !this.motion.matches && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}
